import { SkeletonRow } from '@components/skeleton';

const SKELETON_ROW_WIDTHS = ['w-48', 'w-64'];

const MatchReasonsSkeleton: React.FC = () => (
  <div
    data-testid='match-reasons-skeleton'
    className='-mx-6 border-b border-gray-200 bg-white px-4 py-5 sm:mx-0 sm:mb-2 sm:rounded-2xl sm:border-none lg:mb-4 lg:px-12'>
    <div className='mb-4 h-4 w-48 lg:mb-3'>
      <SkeletonRow />
    </div>
    <div className='flex flex-col gap-3 lg:gap-2.5'>
      {SKELETON_ROW_WIDTHS.map(width => (
        <div key={width} className='flex items-center gap-3'>
          <div className='flex size-6 shrink-0 animate-pulse rounded-full bg-gray-200 lg:size-5' />
          <div className={`h-5 ${width}`}>
            <SkeletonRow />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default MatchReasonsSkeleton;
